export default "__VITE_ASSET__DEhkCgPO__"